import { render, staticRenderFns } from "./priceAudit.vue?vue&type=template&id=264b2d87&scoped=true&"
import script from "./priceAudit.vue?vue&type=script&lang=js&"
export * from "./priceAudit.vue?vue&type=script&lang=js&"
import style0 from "./priceAudit.vue?vue&type=style&index=0&id=264b2d87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b2d87",
  null
  
)

export default component.exports